import React, { useState } from "react";
import styled from "styled-components"
import { useTranslation } from 'react-i18next';
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import eucaly from "./images/EUCALY.png"

const Signup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    agreeToTerms: false,
  });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.firstName) {
      errors.firstName = t("errors.firstNameRequired");
      isValid = false;
    }
    if (!formData.lastName) {
      errors.lastName = t("errors.lastNameRequired");
      isValid = false;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(formData.email)) {
      errors.email = t("errors.invalidEmail");
      isValid = false;
    }

    const phonePattern = /^[0-9]{10}$/;
    if (!phonePattern.test(formData.phoneNumber)) {
      errors.phoneNumber = t("errors.invalidPhone");
      isValid = false;
    }

    const passwordPattern = /^(?=.*[A-Z])(?=.*[0-9!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
    if (!formData.password) {
      errors.password = t("errors.passwordRequired");
      isValid = false;
    } else if (!passwordPattern.test(formData.password)) {
      errors.password = t("errors.invalidPassword");
      isValid = false;
    }

    if (!formData.confirmPassword) {
      errors.confirmPassword = t("errors.confirmPasswordRequired");
      isValid = false;
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = t("errors.passwordMismatch");
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (!validateForm()) {
      return;
    }
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
    try {
      const response = await fetch(`${API_URL}addAccount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage(t("errors.accountCreated"));
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setMessage(t(`errors.${data.messageKey}`) || t("errors.failedCreation"));
      }
    } catch (error) {
      setMessage("Network error. Please try again.");
      console.error("Signup error:", error);
    }
  };

  const handleLoginClick = () => {
    navigate("/login")
  }

  return (
    <ALL>
        <Header/>
        <SignupBody>
            <Form onSubmit={handleSubmit}>
              <SignUpTitle>{t('signup.title')}</SignUpTitle>
                <Input type="text" name="firstName" placeholder={t('signup.firstName')} value={formData.firstName} onChange={handleChange} />
                {errors.firstName && <Error>{errors.firstName}</Error>}
                <Input type="text" name="lastName" placeholder={t('signup.lastName')} value={formData.lastName} onChange={handleChange} />
                {errors.lastName && <Error>{errors.lastName}</Error>}
                <Input type="email" name="email" placeholder={t('signup.email')} value={formData.email} onChange={handleChange} />
                  {errors.email && <Error>{errors.email}</Error>}
                  <PasswordInputWrapper>
                    <Input type={showPassword ? "text" : "password"} name="password" placeholder={t("signup.password")} value={formData.password}onChange={handleChange} />
                    <EyeButton onClick={(e) => { e.preventDefault(); setShowPassword(!showPassword); }}>👁</EyeButton>
                  </PasswordInputWrapper>
                  {errors.password && <Error>{errors.password}</Error>}
                  <PasswordInputWrapper>
                    <Input type={showPassword ? "text" : "password"} name="confirmPassword" placeholder={t("signup.confirmPassword")} value={formData.confirmPassword} onChange={handleChange} />
                    <EyeButton onClick={(e) => { e.preventDefault(); setShowPassword(!showPassword); }}>👁</EyeButton>
                  </PasswordInputWrapper>
                  {errors.confirmPassword && <Error>{errors.confirmPassword}</Error>}
                <Input type="text" name="phoneNumber" placeholder={t('signup.phone')} value={formData.phoneNumber} onChange={handleChange} />
                  {errors.phoneNumber && <Error>{errors.phoneNumber}</Error>}
                  <CheckboxAndText>
                    <CheckboxWrapper>
                    <HiddenCheckbox type="checkbox" name="agreeToTerms" checked={formData.agreeToTerms} onChange={handleChange} />
                    <StyledCheckbox checked={formData.agreeToTerms}>
                      <Checkmark viewBox="0 0 24 24">
                        <polyline points="20 6 9 17 4 12" />
                      </Checkmark>
                    </StyledCheckbox>
                    </CheckboxWrapper>
                      <TermText>{t('signup.termsAgreement')} <a href="/termes-et-conditions" target="_blank" rel="noopener noreferrer">{t('signup.termsLink')}</a></TermText>
                  </CheckboxAndText>
                  {errors.agreeToTerms && <Error>{errors.agreeToTerms}</Error>}
                  {message && <Message>{message}</Message>}
                <Button type="submit">{t('signup.button')}</Button>
              <Textbottom>{t('signup.member')} <LoginSpan onClick={handleLoginClick}>{t('signup.login')}</LoginSpan></Textbottom>
            </Form>
    </SignupBody>
    <Footer/>
    </ALL>
  );
}

export default Signup;

const ALL = styled.div`
background-image: url(${eucaly});
background-color: rgba(148,163,135,1);
`

const SignupBody = styled.div` 
  background-size: cover;
   font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  height: 100vh;
  background-position: top;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom:70px;
  padding-top:70px;
`;

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
`;

const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  box-shadow: 2px black;
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

const StyledCheckbox = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  background: ${props => props.checked ? '#4caf50' : '#fff'};
  border-radius: 60px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  border: 1px solid ${props => props.checked ? '#4caf50' : '#ccc'};
  cursor: pointer;
  overflow: hidden;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.35);
  }

  svg {
    stroke-dasharray: 22;
    stroke-dashoffset: ${props => props.checked ? '0' : '22'};
    transition: stroke-dashoffset 0.3s ease;
  }

  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(76, 175, 80, 0.3); /* green ripple */
    border-radius: 50%;
    transform: scale(0);
    opacity: 0;
    animation: ${props => props.checked ? 'ripple 0.4s ease-out' : 'none'};
    pointer-events: none;
  }

  @keyframes ripple {
    0% {
      transform: scale(0);
      opacity: 0.5;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
`;

const Checkmark = styled.svg`
  width: 16px;
  height: 16px;
  stroke: white;
  stroke-width: 5;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
`;

const CheckboxAndText = styled.div`
display: flex;
`

const TermText = styled.p`
padding-left: 10px;
font-size: 15px;
`

const SignUpTitle = styled.p`
font-size: 30px;
text-align: center;
font-weight: bold;
color: black;
`
const LoginSpan = styled.span`
cursor: pointer;
text-decoration: underline;
`;
const Textbottom = styled.p`
text-align: center;
color: black;
font-weight: bold;
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  margin-top: -90px;
  padding: 10px;
   background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;
const Error = styled.p`
  color: red;
  font-size: 14px;
  margin-top: -10px;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  width:275px;
  border: 1px solid gray;
  margin-bottom: 15px;
`;

const Button = styled.button`
  background-color: rgba(148,163,135,1);
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
  font-weight:bold;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: rgba(186,204,171,1);
  }
`;

const Message = styled.p`
  color: red;
  font-weight: bold;
  text-align: center;
`;
const PasswordInputWrapper = styled.div`
  position: relative;
  width: 300px;
`;

const EyeButton = styled.button`
  position: absolute;
  right: 10px;
  top: 35%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
`;